var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Warning",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 10.0989L148 137.917H0L74 10.0989ZM69.5239 96.9035C69.7752 97.0729 70.058 97.1576 70.3723 97.1576H78.7621C79.0763 97.1576 79.3277 97.0729 79.5162 96.9035C79.7676 96.6777 79.8933 96.4236 79.8933 96.1413L81.3073 59.2154C81.3073 58.9331 81.1816 58.7073 80.9302 58.5379C80.7417 58.312 80.4903 58.1991 80.1761 58.1991H69.1468C68.8326 58.1991 68.5498 58.312 68.2984 58.5379C68.1098 58.7073 68.0156 58.9331 68.0156 59.2154L69.2411 96.1413C69.2411 96.4236 69.3353 96.6777 69.5239 96.9035ZM68.6754 115.536C70.1209 116.778 71.912 117.399 74.0487 117.399C76.1854 117.399 77.9451 116.778 79.3277 115.536C80.7103 114.237 81.4016 112.628 81.4016 110.708C81.4016 108.732 80.7103 107.123 79.3277 105.881C78.0079 104.639 76.2483 104.018 74.0487 104.018C71.8491 104.018 70.058 104.639 68.6754 105.881C67.2929 107.123 66.6016 108.732 66.6016 110.708C66.6016 112.628 67.2929 114.237 68.6754 115.536Z",
    fill: "#FFE664"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warningYellow.0204c66b9b599cf1bd900ec5064efb22.svg";
export { ForwardRef as ReactComponent };